import type { Invite } from './invite.type.ts';
export interface InviteExtension extends Invite {}
export class InviteExtension {
  get isExpired() {
    return new Date(this.expirationDate) < new Date();
  }
}

const Registration = {
  kind: 'object',
  name: 'invite',
  features: InviteExtension,
};
export default Registration;
